/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var FilingCardStateRule;
(function (FilingCardStateRule) {
    var type;
    (function (type) {
        type["FILING_CARD_TYPE_UNKNOWN"] = "FILING_CARD_TYPE_UNKNOWN";
        type["FILING_CARD_TYPE_EXTENSION"] = "FILING_CARD_TYPE_EXTENSION";
        type["FILING_CARD_TYPE_DIY_RETURN"] = "FILING_CARD_TYPE_DIY_RETURN";
        type["FILING_CARD_TYPE_DFY_RETURN"] = "FILING_CARD_TYPE_DFY_RETURN";
    })(type = FilingCardStateRule.type || (FilingCardStateRule.type = {}));
    var state;
    (function (state) {
        state["FILING_CARD_STATE_UNKNOWN"] = "FILING_CARD_STATE_UNKNOWN";
        state["FILING_CARD_STATE_ENABLED"] = "FILING_CARD_STATE_ENABLED";
        state["FILING_CARD_STATE_ALERT"] = "FILING_CARD_STATE_ALERT";
        state["FILING_CARD_STATE_PREMIUM"] = "FILING_CARD_STATE_PREMIUM";
        state["FILING_CARD_STATE_HIDDEN"] = "FILING_CARD_STATE_HIDDEN";
    })(state = FilingCardStateRule.state || (FilingCardStateRule.state = {}));
    var funnelType;
    (function (funnelType) {
        funnelType["FUNNEL_TYPE_UNKNOWN"] = "FUNNEL_TYPE_UNKNOWN";
        funnelType["FUNNEL_TYPE_FILESMART"] = "FUNNEL_TYPE_FILESMART";
        funnelType["FUNNEL_TYPE_FILETAX"] = "FUNNEL_TYPE_FILETAX";
    })(funnelType = FilingCardStateRule.funnelType || (FilingCardStateRule.funnelType = {}));
    var primaryAction;
    (function (primaryAction) {
        primaryAction["FILING_CARD_ACTION_UNKNOWN"] = "FILING_CARD_ACTION_UNKNOWN";
        primaryAction["FILING_CARD_ACTION_REDIRECT"] = "FILING_CARD_ACTION_REDIRECT";
        primaryAction["FILING_CARD_ACTION_NONE"] = "FILING_CARD_ACTION_NONE";
        primaryAction["FILING_CARD_ACTION_SHOW_OFFER"] = "FILING_CARD_ACTION_SHOW_OFFER";
        primaryAction["FILING_CARD_ACTION_TO_EXTENSION"] = "FILING_CARD_ACTION_TO_EXTENSION";
        primaryAction["FILING_CARD_ACTION_DISABLED"] = "FILING_CARD_ACTION_DISABLED";
        primaryAction["FILING_CARD_ACTION_ENABLE_CARD"] = "FILING_CARD_ACTION_ENABLE_CARD";
    })(primaryAction = FilingCardStateRule.primaryAction || (FilingCardStateRule.primaryAction = {}));
    var secondaryAction;
    (function (secondaryAction) {
        secondaryAction["FILING_CARD_ACTION_UNKNOWN"] = "FILING_CARD_ACTION_UNKNOWN";
        secondaryAction["FILING_CARD_ACTION_REDIRECT"] = "FILING_CARD_ACTION_REDIRECT";
        secondaryAction["FILING_CARD_ACTION_NONE"] = "FILING_CARD_ACTION_NONE";
        secondaryAction["FILING_CARD_ACTION_SHOW_OFFER"] = "FILING_CARD_ACTION_SHOW_OFFER";
        secondaryAction["FILING_CARD_ACTION_TO_EXTENSION"] = "FILING_CARD_ACTION_TO_EXTENSION";
        secondaryAction["FILING_CARD_ACTION_DISABLED"] = "FILING_CARD_ACTION_DISABLED";
        secondaryAction["FILING_CARD_ACTION_ENABLE_CARD"] = "FILING_CARD_ACTION_ENABLE_CARD";
    })(secondaryAction = FilingCardStateRule.secondaryAction || (FilingCardStateRule.secondaryAction = {}));
})(FilingCardStateRule || (FilingCardStateRule = {}));
//# sourceMappingURL=FilingCardStateRule.js.map